import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFreshcallerRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 31 31",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#CC4783",
		d: "M15.762 5.029H23.626a2.641 2.641 0 0 1 2.641 2.641v7.864A10.445 10.445 0 0 1 15.822 25.98h-.06A10.445 10.445 0 0 1 5.316 15.534 10.445 10.445 0 0 1 15.762 5.029Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M19.696 17.123c-.556 0-1.172-.06-1.728-.298-.238-.119-.496-.06-.675.119l-.914.973a7.04 7.04 0 0 1-3.018-3.019l1.052-.973c.12-.179.18-.437.12-.615-.179-.556-.298-1.112-.298-1.728 0-.377-.238-.616-.556-.675h-1.787c-.378 0-.616.238-.675.556v.06c0 4.667 3.813 8.48 8.539 8.48.377 0 .616-.239.675-.556v-1.728c0-.377-.238-.616-.556-.675h-.06Z"
	})]
});
export default SvgFreshcallerRegularIcon;
